import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
  Box,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { DENY_NOTE_MAX } from 'constants/fieldLimits';

const DenyDialog = ({
  setDialogOpen,
  type,
  setNote,
  onDeny,
  isProcessing,
  isDialogOpen,
  note = '',
  requestedBy = { firstName: '', lastName: '' },
}) => (
  <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)} data-cy="deny-dialog">
    <DialogTitle>
      Do you want to add a note?
      <IconButton
        aria-label="close"
        onClick={() => setDialogOpen(false)}
        sx={{ position: 'absolute', right: 8, top: 8 }}
        size="large"
      >
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        The {`${type}`} request (requested by: {`${requestedBy.firstName} ${requestedBy.lastName}`})
        has been denied. Please, write an explanation note.
      </DialogContentText>
      <TextField
        fullWidth
        id="note"
        label="Note"
        name="note"
        placeholder="Enter a note"
        multiline
        maxRows="6"
        value={note || ''}
        onChange={e => setNote(e.target.value)}
        margin="normal"
        inputProps={{ maxLength: DENY_NOTE_MAX }}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          fontWeight: 300,
          fontSize: '12px',
          lineHeight: '14px',
          marginTop: '4px',
        }}
      >
        {note.length}/{DENY_NOTE_MAX}
        {note.length >= DENY_NOTE_MAX && (
          <Box component="span" sx={{ color: 'error.main', marginLeft: '8px' }}>
            Maximum length reached
          </Box>
        )}
      </Box>
      <DialogActions>
        <Button onClick={e => onDeny(e, false)}>Proceed</Button>
        <Button disabled={isProcessing} onClick={e => onDeny(e, true)} data-cy="noteSubmit">
          Add a note
        </Button>
      </DialogActions>
    </DialogContent>
  </Dialog>
);

export default DenyDialog;
